<template>
  <q-layout
      view="lhh LpR lff"
      container
      class="shadow-2 rounded-borders window-height"
      :class="$q.dark.isActive ? 'bg-grey-9' : 'bg-grey-3'"
  >
    <q-header class="bg-primary">
      <q-toolbar>
        <q-toolbar-title>Обмен заявками</q-toolbar-title>
        <q-btn flat @click="drawerRight = !drawerRight" round dense icon="menu"/>
      </q-toolbar>
    </q-header>


    <q-drawer
        side="right"
        v-model="drawerRight"
        bordered
        :width="250"
        :breakpoint="500"
    >
      <q-scroll-area class="fit">
        <div class="q-pa-sm">
          <q-option-group
              v-model="activeServices"
              :options="services"
              color="green"
              type="checkbox"
              @update:model-value="checkActiveTab"
          >
            <template v-slot:label="service">
              <div class="row items-center exportServiceName">

                                <span>
                                    <q-badge rounded color="blue"
                                             :label="settings.services[service.value].priority ?? 0"/>
                                    {{ service.label }}
                                </span>
                <q-badge
                    v-if="settings.services[service.value] && settings.services[service.value].sites && settings.services[service.value].sites.length"
                    color="blue"
                    class="exportServiceBadge">
                  {{ settings.services[service.value].sites.length }}
                </q-badge>
                <q-badge v-if="settings.services[service.value] && settings.services[service.value].override
                                && typeof settings.services[service.value].override.model === 'object'
                                && Object.keys(settings.services[service.value].override.model).length !== 0
                                " color="red"
                         class="exportServiceBadge">
                  {{ settings.services[service.value].override.model.length }}
                </q-badge>
              </div>
            </template>
          </q-option-group>

        </div>
        <div class="q-pa-sm fixed-bottom bg-white">
          <q-btn class="full-width" :loading="isLoading" :disabled="isLoading" color="primary"
                 @click="saveSettings" label="Сохранить"/>
        </div>
      </q-scroll-area>
    </q-drawer>

    <q-page-container>
      <q-page style="padding-top: 30px" class="q-pa-md">

        <q-tabs v-model="activeServicesTab" v-if="activeServices.length">
          <template v-for="service in services" :key="service.value">
            <q-tab :name="service.value" v-if="activeServices.includes(service.value)">
              {{ service.label }}
            </q-tab>
          </template>
        </q-tabs>

        <q-banner v-else class="text-white bg-red">
          Отправка лидов остановлена. Ни один сервис не активирован.
        </q-banner>


        <q-tab-panels v-model="activeServicesTab" v-if="activeServices.length">
          <q-tab-panel v-for="(service, serviceIndex) in services" :key="serviceIndex" :name="service.value"
                       class="settingsPanel900">

            <h5>Приоритет</h5>
            <q-slider
                class="q-mt-xl"
                v-model="settings.services[service.value].priority"
                color="deep-orange"
                label-always
                markers
                marker-labels
                :min="1"
                :max="Object.keys(settings.services).length"
                @change="updateServiceSort"
            >
              <template v-slot:marker-label-group="scope">
                <div
                    v-for="marker in scope.markerList"
                    :key="marker.index"
                    :class="[ `text-deep-orange-${2 + Math.ceil(marker.value / 2) }`, marker.classes ]"
                    :style="marker.style"
                    @click="model = marker.value"
                >{{ marker.value }}
                </div>
              </template>
            </q-slider>

            <div class="row interfaceGap">

              <div class="col">
                <h6>Мин {{ settings.services[service.value].redirect ? 'редиректов' : 'лидов' }} в сутки</h6>
                <div class="inputSpinner">
                  <button @click="decreaseValue(service.value, 'minimum')">-</button>
                  <input
                      v-model.number="settings.services[service.value].minimum"
                      type="number"
                      min="0"
                  >
                  <button @click="increaseValue(service.value, 'minimum')">+</button>
                </div>
              </div>

              <div class="col">
                <h6>Макс {{ settings.services[service.value].redirect ? 'редиректов' : 'лидов' }} в сутки</h6>
                <div class="inputSpinner">
                  <button @click="decreaseValue(service.value, 'limit')">-</button>
                  <input
                      v-model.number="settings.services[service.value].limit"
                      type="number"
                      min="0"
                  >
                  <button @click="increaseValue(service.value, 'limit')">+</button>
                </div>
              </div>

              <div class="col">
                <h6>Тип приема</h6>
                <div class="exchangeType">
                  <q-btn-toggle
                      v-model="settings.services[service.value].redirect"
                      spread
                      no-caps
                      toggle-color="primary"
                      color="white"
                      text-color="black"
                      unelevated
                      :options="[
                                          {label: 'Обычный', value: false},
                                          {label: 'Редирект', value: true}
                                        ]"
                  />
                </div>
              </div>
            </div>

            <div class="q-my-md q-mt-lg">

              <q-toggle
                  label="Фиксированная ставка за успешный лид (в долларах)"
                  color="deep-orange"
                  size="lg"
                  v-model="settings.services[service.value].fixed_rate"
              />

              <div class="row interfaceGap">
                <div class="col" v-if="settings.services[service.value].fixed_rate">
                  <div class="inputSpinner">
                    <button @click="decreaseValue(service.value, 'fixed_rate_value', 0.01)">-</button>
                    <input
                        v-model.number="settings.services[service.value].fixed_rate_value"
                        type="number"
                        min="0"
                        step="0.01"
                    >
                    <button @click="increaseValue(service.value, 'fixed_rate_value', 0.01)">+</button>
                  </div>
                </div>

              </div>

              <p class="attention" v-if="settings.services[service.value].fixed_rate">
                Внимание! Не включайте эту опцию, если вы планируете получать постбеки от партнера!
              </p>

            </div>

            <h5>Сайты</h5>
            <q-select
                filled
                v-model="settings.services[service.value].sites"
                multiple
                :options="objectToOptions(settings.sites)"
                counter
                use-chips
                stack-label
                label="Выберите сайты"
            />
            <p>Сайты, лиды с которых будут отправляться в сервис {{ service.label }}</p>

            <div class="row col-12 q-mt-lg">
              <div class="text-h6 q-mb-sm">Не работать с указанными UTM</div>

              <div
                  v-for="(field, index) in getUtmExcludeArray(service.value)"
                  :key="index"
                  class="row items-start col-12"
              >
                <q-field
                    class="col-3 q-pr-sm"
                    :model-value="field.utm_source"
                    @update:model-value="value => updateUtmExcludeRow(service.value, index, 'utm_source', value)"
                    label="UTM Source *"
                    :rules="[val => !!val || 'Обязательное поле']"
                    outlined
                    stack-label
                >
                  <template v-slot:control>
                    <input
                        :value="field.utm_source"
                        @input="e => updateUtmExcludeRow(service.value, index, 'utm_source', e.target.value)"
                        class="q-field__input"
                        placeholder="Введите UTM Source"
                    >
                  </template>
                </q-field>

                <q-field
                    class="col-8 q-pr-sm"
                    :model-value="field.utm_campaign"
                    @update:model-value="value => updateUtmExcludeRow(service.value, index, 'utm_campaign', value)"
                    label="UTM Campaign (можно задать несколько, разделять запятой)"
                    outlined
                    stack-label
                >
                  <template v-slot:control>
                    <input
                        :value="field.utm_campaign"
                        @input="e => updateUtmExcludeRow(service.value, index, 'utm_campaign', e.target.value)"
                        class="q-field__input"
                        placeholder="Введите UTM Campaign"
                    >
                  </template>
                </q-field>

                <div class="col-1">
                  <q-btn
                      v-if="getUtmExcludeArray(service.value).length > 0"
                      @click="removeUtmExcludeRow(service.value, index)"
                      icon="delete"
                      color="negative"
                      flat
                      round
                  />
                </div>
              </div>

              <q-btn
                  @click="addUtmExcludeRow(service.value)"
                  icon="add"
                  label="Добавить UTM"
                  color="primary"
                  outline
                  class="q-mb-md col-12"
              />
            </div>

            <h5>Фильтр лидов</h5>
            <site-filters :settings="settings" :service="service"/>

            <q-banner class="bg-blue-2 text-black">
              Чекбокс имеет 3 значения - да (галочка), нет (пусто) и не учитывать (чёрточка)
            </q-banner>

            <h5>Переопределение настроек</h5>
            <q-select
                filled
                v-model="settings.services[service.value].override.model"
                multiple
                :options="objectToOptions(settings.sites)"
                counter
                use-chips
                stack-label
                label="Выберите сайты"
            />
            <p>Выберите сайты, на которых нужно переопределить настройоки по умолчанию</p>


            <div v-if="settings.services[service.value].override">
              <div v-for="(site, siteIndex) in settings.services[service.value].override.model"
                   :key="siteIndex">
                <q-expansion-item
                    dense-toggle
                    switch-toggle-side
                    expand-separator
                >
                  <template v-slot:header>
                    <q-item-section>
                      {{ site.label }}
                    </q-item-section>
                    <q-item-section side>
                      <q-badge v-if="!isItemPresent(settings.services[service.value].sites, 'label', site.label)"
                               color="red"
                               class="exportServiceBadge">Не активен
                      </q-badge>
                      <q-badge v-if="isItemPresent(settings.services[service.value].sites, 'label', site.label)"
                               color="green"
                               class="exportServiceBadge">Активен
                      </q-badge>
                    </q-item-section>
                  </template>
                  <q-banner v-if="!isItemPresent(settings.services[service.value].sites, 'label', site.label)"
                            class="bg-yellow text-black">
                    Этот сайт не активирован, лиды с него отправляться не будут.
                  </q-banner>
                  <site-filters :settings="settings" :service="service"
                                :siteId="site.label.replace(/\./g, '')" @submit="handleSettingsSubmit"/>
                </q-expansion-item>

              </div>
            </div>

          </q-tab-panel>
        </q-tab-panels>

      </q-page>

    </q-page-container>
  </q-layout>
</template>

<script setup>
import {onMounted, ref, watch} from "vue"
import {ajax, isItemPresent, objectToOptions} from "@/assets/js/functions"
import SiteFilters from "@/components/ExchangeSettings/SiteFilters.vue"

const isLoading = ref(true)
const settings = ref({})
const services = ref([])
const activeServices = ref([])
const activeServicesTab = ref('')
const drawerRight = ref(true)

onMounted(() => {
  ajax({action: "getLeadExchangeSettings"}, (data) => {
    settings.value = data
    services.value = objectToOptions(data.services, data.services)
    if (data.activeServices) {
      activeServices.value = data.activeServices
      activeServicesTab.value = data.activeServices[0]
    }
    isLoading.value = false
  })
})

const getUtmExcludeArray = (service) => {
  const utmExclude = settings.value.services[service]?.utm_exclude

  if (Array.isArray(utmExclude)) {
    return utmExclude
  } else if (utmExclude && typeof utmExclude === 'object') {
    return Object.values(utmExclude)
  } else {
    return []
  }
}

const normalizeUtmExclude = (service) => {
  const utmExclude = settings.value.services[service]?.utm_exclude

  if (!utmExclude) {
    settings.value.services[service].utm_exclude = []
  } else if (utmExclude && typeof utmExclude === 'object' && !Array.isArray(utmExclude)) {
    settings.value.services[service].utm_exclude = Object.values(utmExclude)
  }
}

const addUtmExcludeRow = (service) => {
  normalizeUtmExclude(service)
  settings.value.services[service].utm_exclude.push({
    utm_source: '',
    utm_campaign: ''
  })
}

const validateUtmFields = () => {
  let hasErrors = false
  let errorMessages = []

  Object.keys(settings.value.services).forEach(service => {
    const utmArray = getUtmExcludeArray(service)
    const serviceName = settings.value.services[service]?.name || service

    utmArray.forEach((field, index) => {
      if (!field.utm_source || field.utm_source.trim() === '') {
        hasErrors = true
        errorMessages.push(`Сервис "${serviceName}" - строка ${index + 1}: не заполнено обязательное поле "UTM Source"`)
      }
    })
  })

  return {
    isValid: !hasErrors,
    errors: errorMessages
  }
}

const removeUtmExcludeRow = (service, index) => {
  normalizeUtmExclude(service)
  if (settings.value.services[service].utm_exclude.length > 0) {
    settings.value.services[service].utm_exclude.splice(index, 1)
  }
}

const updateUtmExcludeRow = (service, index, fieldName, value) => {
  normalizeUtmExclude(service)
  settings.value.services[service].utm_exclude[index][fieldName] = value
}

watch(() => settings.value, (newSettings) => {
  if (newSettings.services) {
    Object.keys(newSettings.services).forEach(service => {
      normalizeUtmExclude(service)
    })
  }
}, { deep: true, immediate: true })

const decreaseValue = (service, value, step = 100) => {
  let inputValue = parseFloat(settings.value.services[service][value])
  settings.value.services[service][value] = inputValue - step

  if (inputValue <= step)
    settings.value.services[service][value] = 0

}

const increaseValue = (service, value, step = 100) => {
  let inputValue = parseFloat(settings.value.services[service][value])
  settings.value.services[service][value] = inputValue + step
}

const checkActiveTab = () => {
  let services = activeServices.value
  if (activeServices.value.length && !services.includes(activeServicesTab.value)) {
    activeServicesTab.value = services[0];
  }
}

const saveSettings = () => {
  const validation = validateUtmFields()

  if (!validation.isValid) {
    const errorMessage = 'Обнаружены ошибки в заполнении UTM полей:\n\n' +
        validation.errors.join('\n') +
        '\n\nПожалуйста, заполните все обязательные поля.'
    alert(errorMessage)
    return
  }

  isLoading.value = true
  settings.value.activeServices = activeServices.value
  ajax(
      {
        action: "saveLeadExchangeSettings",
        settings: settings.value
      },
      (data) => {
        isLoading.value = false
      }
  )
}

const handleSettingsSubmit = (data) => {
  settings.value = data
}

const updateServiceSort = () => {
  services.value = objectToOptions(settings.value.services, settings.value.services)
}


</script>

<style>
h5, h6 {
  margin-bottom: 20px;
}

.exportServiceName {
  position: relative;
}

.exportServiceBadge {
  margin-left: 5px;
}

.settingsPanel900 {
  width: 100%;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
}

.inputSpinner {
  display: flex;
  align-items: stretch;
  -moz-appearance: textfield;
  -webkit-appearance: none;
  appearance: textfield;

  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
}

.inputSpinner input::-webkit-outer-spin-button,
.inputSpinner input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.inputSpinner > button {
  width: 60px;
  background: transparent;
  border: 0;
  font-size: 30px;
  cursor: pointer;
}

.inputSpinner > input {
  text-align: center;
  font-size: 25px;
  flex: 0 0 200px;
  max-width: 200px;
}
.inputSpinner > .value {
  text-align: center;
  font-size: 25px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 5px;
}

.interfaceGap {
  gap: 40px;
}

.interfaceGap > div.col {
  max-width: 262px;
}
.attention {
  padding: 10px;
  background: #FFEB3B;
  border-radius: 8px;
}
</style>
